import React from "react";
import BannerAll from "../../components/ourStory/Banner";
import StoryIntro from "../../components/ourStory/Intro";
import OurTeam from "../../components/ourStory/Team";
import StoryVideo from "../../components/ourStory/storyVideo";
import HomeAbout from "../../components/HomeAbout";

const OurSTory = () => {
  return (
    <>
      {/* <BannerAll /> */}
      <StoryIntro />
      <OurTeam />
      {/* <StoryVideo videoLink="https://www.youtube.com/watch?v=gcvafaJGfOc&t=21s" /> */}
      <HomeAbout isGamePage={true} />
    </>
  );
};

export default OurSTory;
